import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { QuizInfo as TakeQuizInfo } from '@instructure/quiz-core';
export var TakeHeader = /*#__PURE__*/function (_Component) {
  function TakeHeader() {
    _classCallCheck(this, TakeHeader);
    return _callSuper(this, TakeHeader, arguments);
  }
  _inherits(TakeHeader, _Component);
  return _createClass(TakeHeader, [{
    key: "renderInfo",
    value: function renderInfo() {
      var quiz = this.props.quiz;
      var hideInstructions = this.props.hideInstructions;
      return /*#__PURE__*/React.createElement(TakeQuizInfo, {
        quiz: quiz,
        hideInstructions: hideInstructions
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.renderInfo());
    }
  }]);
}(Component);
// TODO: Refactor this component so that it's not relying on props that aren't used internally.  The is prop is
// exclusively used by the redux connecting logic in index.js
_defineProperty(TakeHeader, "propTypes", {
  quizSessionId: PropTypes.string.isRequired,
  quiz: ImmutablePropTypes.record.isRequired,
  hideInstructions: PropTypes.bool
});
_defineProperty(TakeHeader, "defaultProps", {
  hideInstructions: false
});
export default TakeHeader;